import React, { useEffect, useState } from "react";
//import { useSelector } from "react-redux";
import { CAMPAIGN_STATUS, campaignsStatus } from "../../utils/enum/enums";
import { sortByText } from "../../utils/sort/sort";
//import { useNotifications } from "../../context/Notifications";
//import { IsAllow } from "../../utils/allowHelper/AllowHelper";
import { useTranslator } from "../../context/translator";
function CampaignsEditModal({ campaign }) {
  //const { user } = useSelector((state) => state.user);
  //const { addNotification } = useNotifications();
  const [modalOpen, setModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [comment, setComment] = useState("");
  const [type, setType] = useState(campaignsStatus.ACTIVE);
  //const { data: company } = useGetCompanyQuery(user.companyId);
  const { translate } = useTranslator();
  const [options, setOptions] = useState([
    {
      id: campaignsStatus.ACTIVE,
      text: translate("active"),
    },

    {
      id: campaignsStatus.PAUSED,
      text: translate("paused"),
    },
    {
      id: campaignsStatus.FINISHED,
      text: translate("finished"),
    },
  ]);

  const toggleModal = () => {
    setIsLoading(false);
    setType(campaignsStatus.ACTIVE);

    setComment("");
    setModalOpen(!modalOpen);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    setIsLoading(true);

    setIsLoading(false);
  };

  const onChangeMessage = (event) => {
    const value = event.target.value;
    setComment(value);
  };

  const onChangeType = (event) => {
    const value = event.target.value;
    setType(value);
  };

  const getDepositTypesCall = React.useCallback(async () => {}, []);

  useEffect(() => {
    setOptions((options) => {
      return sortByText(options);
    });

    getDepositTypesCall();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <button
        className="text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2 disabled:bg-gray-400 disabled:hover:bg-gray-400 disabled:cursor-not-allowed"
        onClick={toggleModal}
        disabled={campaign.status === CAMPAIGN_STATUS.COMPLETED}
        type="button"
      >
        {translate("edit")}
      </button>

      {modalOpen && (
        <div
          id="modalID"
          tabIndex="-1"
          aria-hidden="true"
          className="fixed top-0 right-0 left-0 z-50 flex justify-center items-center w-full h-full bg-black bg-opacity-50 overflow-y-auto"
        >
          <div className="relative p-4 w-full max-w-2xl max-h-full">
            <div className="relative bg-white rounded-lg shadow dark:bg-gray-700">
              <div className="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600">
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white">
                  {translate("campaign")}
                </h3>
                <button
                  type="button"
                  className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                  data-modal-hide="modalID"
                  onClick={toggleModal}
                  disabled={isLoading}
                >
                  <svg
                    className="w-3 h-3"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 14 14"
                  >
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                    />
                  </svg>
                  <span className="sr-only">Close modal</span>
                </button>
              </div>
              <div className="p-4 md:p-5">
                <div className="mb-6">
                  <label
                    htmlFor="type"
                    className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    {translate("select-type")}
                  </label>
                  <select
                    id="type"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    defaultValue={type}
                    required
                    onChange={onChangeType}
                  >
                    {options.map((option) => (
                      <>
                        <option key={option.id} value={option.id}>
                          {option.text}
                        </option>
                      </>
                    ))}
                  </select>
                </div>

                <div className="mb-6">
                  <label
                    htmlFor="comment"
                    className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    required
                  >
                    {translate("description")}
                  </label>
                  <textarea
                    id="comment"
                    rows="4"
                    className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    placeholder={translate("description") + "..."}
                    defaultValue={comment}
                    required
                    onChange={onChangeMessage}
                  ></textarea>
                </div>

                <div className="flex justify-between items-center">
                  <button
                    data-modal-hide="modalID"
                    type="button"
                    className="py-2.5 px-5 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-100 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700"
                    onClick={toggleModal}
                    disabled={isLoading}
                  >
                    {translate("cancel")}
                  </button>
                  <button
                    type="button"
                    className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
                    onClick={handleSubmit}
                    disabled={isLoading}
                  >
                    {translate("save")}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default CampaignsEditModal;
